import React from 'react';

type CommentIconProps = {
  className?: string;
};

const svgProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 18 18',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
} as const;

/** History clock for the comments tab. Fill follows currentColor via {@link Icon}. */
export const CommentIcon: React.FC<CommentIconProps> = ({ className }) => (
  <svg {...svgProps} className={className}>
    <path
      fill="currentColor"
      d="M13.5 9C13.5 6.51472 11.4853 4.5 9 4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5C11.4853 13.5 13.5 11.4853 13.5 9ZM14.5 9C14.5 12.0376 12.0376 14.5 9 14.5C5.96243 14.5 3.5 12.0376 3.5 9C3.5 5.96243 5.96243 3.5 9 3.5C12.0376 3.5 14.5 5.96243 14.5 9Z"
    />
    <path
      fill="currentColor"
      d="M9.5 5.5V9.20703L7.85352 10.8535C7.65825 11.0488 7.34175 11.0488 7.14648 10.8535C6.95122 10.6583 6.95122 10.3417 7.14648 10.1465L8.5 8.79297V5.5H9.5Z"
    />
  </svg>
);

/** Same clock with a blue dot when another user has an unread comment. */
export const CommentUnreadIcon: React.FC<CommentIconProps> = ({
  className,
}) => (
  <svg {...svgProps} className={className}>
    <path
      fill="currentColor"
      d="M3.5 9C3.5 5.96243 5.96243 3.5 9 3.5V4.5C6.51472 4.5 4.5 6.51472 4.5 9C4.5 11.4853 6.51472 13.5 9 13.5C11.4853 13.5 13.5 11.4853 13.5 9H14.5C14.5 12.0376 12.0376 14.5 9 14.5C5.96243 14.5 3.5 12.0376 3.5 9Z"
    />
    <path
      fill="currentColor"
      d="M9.5 5.5V9.20703L7.85352 10.8535C7.65825 11.0488 7.34175 11.0488 7.14648 10.8535C6.95122 10.6583 6.95122 10.3417 7.14648 10.1465L8.5 8.79297V5.5H9.5Z"
    />
    <circle cx="14" cy="4" r="3" fill="#0B99FF" />
  </svg>
);
